import {
  Component,
  Input,
  AfterContentChecked,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { trimTextByWord } from "../../admin/events-screen/utils/trimTextByWord";

@Component({
  selector: "app-spinner",
  template: `
    <div class="relative w-10 h-10">
      <img
        class="absolute animate-spin"
        alt="app-spinner"
        src="../../../assets/svg/spinner/app-spinner.svg"
      />
    </div>
  `,
  styleUrls: ["./app-spinner.component.scss"],
})
export class AppSpinnerComponent {
  constructor() {}
}



// WEBPACK FOOTER //
// ./src/app/common/app-spinner/app-spinner.component.ts